var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"displayBetween",staticStyle:{"height":"100%","width":"100%"},attrs:{"id":"RightTwo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }